/** Cached session: the non-secret /me payload, so the app can boot offline. */
import type { Me } from '@/lib/api/types';

import { db } from './db';

export async function getCachedSession(): Promise<Me | null> {
  const record = await db.session.get('current');
  return record?.me ?? null;
}

export async function saveCachedSession(me: Me): Promise<void> {
  await db.session.put({ key: 'current', me, cached_at: new Date().toISOString() });
}
